import React from 'react'

function Body() {

const [title , settitle] = React.useState();
const [subject , setsubject] = React.useState();


function handlex()
{

    settitle("HackScript");
    setsubject("HackScript is a student community built with the vision to encourage development ! We provide the best resources, conducts contests, hackathons, workshops, sessions to test your skills, a guide to Open-source, and help you build projects.")


}
function handley()
{

    settitle("Developer Console");
    setsubject("We created console , a platform where developer deploy their project online and view , review various hosted preoject of different developers  , we called it home of developers")


}

function handlez()
{
    settitle("Weekly Challenges");
    setsubject("Challenges hit your weakness and boost up your potential to do something great , we give you weekly challanges , and yes if you are top in weekly leaderboard you can win a hackscript tshirt")


}


function handlea()
{
    settitle("LeaderBoard");
    setsubject("If you are a good developer we spotlight you in our leaderboard with your skills and efficiency of doing things so anyone who need you can hire you directly ")



}




  return (
   <>
   <section className="text-gray-600 body-font">
  <div className="container px-5 py-20 mx-auto">
    <div className="flex flex-col text-center w-full mb-20">
      <h1 className="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">
      {title}
      </h1>
      <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
     {subject}
      </p>
    </div>
    <div className="flex flex-wrap -m-4 text-center ">
      <div className="p-4 md:w-1/4 sm:w-1/2 w-full ">
        <div className="border-2 border-gray-200 px-4 py-6 rounded-lg  hover:bg-blue-100" onClick={handlex}>
          <svg
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            className="text-indigo-500 w-12 h-12 mb-3 inline-block"
            viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
          </svg>

        

          <p className="leading-relaxed">About HackScript
          
            </p>
        </div>
      </div>
      <div className="p-4 md:w-1/4 sm:w-1/2 w-full">
        <div className="border-2 border-gray-200 px-4 py-6 rounded-lg   hover:bg-blue-100" onClick={handley} >
          <svg
          
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            className="text-indigo-500 w-12 h-12 mb-3 inline-block"
            viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 7.5l3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0021 18V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v12a2.25 2.25 0 002.25 2.25z" />
          
          </svg>
         
          <p className="leading-relaxed">Console</p>
        </div>
      </div>
      <div className="p-4 md:w-1/4 sm:w-1/2 w-full">
        <div className="border-2 border-gray-200 px-4 py-6 rounded-lg   hover:bg-blue-100" onClick={handlez}>
          <svg
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            className="text-indigo-500 w-12 h-12 mb-3 inline-block"
            viewBox="0 0 24 24"
          >

<path stroke-linecap="round" stroke-linejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
          </svg>
        
          <p className="leading-relaxed">Challenges</p>
        </div>
      </div>
      <div className="p-4 md:w-1/4 sm:w-1/2 w-full " onClick={handlea}>
        <div className="border-2 border-gray-200 px-4 py-6 rounded-lg   hover:bg-blue-100">
          <svg
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            className="text-indigo-500 w-12 h-12 mb-3 inline-block"
            viewBox="0 0 24 24"
          >
<path stroke-linecap="round" stroke-linejoin="round" d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z" />
          </svg>

          <p className="leading-relaxed">LeaderBoard</p>
        </div>
      </div>
    </div>
  </div>
</section>

   </>
  )
}

export default Body